export const PRODUCT_IMAGE_ANIMATION_DURATION = 500;

// Ensure a default min height for small images.
export const MOBILE_SAFETY_MEASURE = '100px';
